<template>
  <view-layout v-bind="$attrs"  footer-color="transparent" footer-class="text-left">
    <template v-if="$slots.title" slot="title">
      <text-h3 class="mt-3"><slot name="title"></slot></text-h3>
    </template>

    <v-card flat dark tile class="text-left px-4 pb-4" color="primary" :style="styleCard">
      <text-h2 class="mb-0"><slot name="subtitle"></slot></text-h2>
    </v-card>

    <v-card light flat class="d-flex flex-column text-center rounded-t-lg mt-n4" color="white">
      <v-card  light class="text-center ma-4 rounded-lg" :style="styleFloating" style="box-shadow: 0px 4px 20px 0px #5151511F" >
        <slot name="floating"></slot>
      </v-card>
      <slot></slot>
    </v-card>

    <!--footer-->
    <template v-if="$slots.footer || $slots['footer-left'] || $slots['footer-right']" slot="footer">
      <v-row no-gutters align="center" class="py-4 px-4" style="background-color: rgba(255, 255, 255, 0.9)">

        <!--footer: alinha ao centro - usado sozinho-->
        <v-col v-if="!!$slots.footer" cols="12"><slot name="footer"></slot></v-col>

        <!--footer-left: alinha esquerda-->
        <v-col v-if="!$slots.footer" cols="auto" class="mr-auto">
          <slot name="footer-left"></slot>
        </v-col>

        <!--footer-right: alinha direita-->
        <v-col v-if="!$slots.footer" cols="auto">
          <slot name="footer-right"></slot>
        </v-col>
      </v-row>
    </template>
  </view-layout>
</template>
<script>
export default {
  props: {
    margin: { type: [Number, String], default: 0 }
  },
  computed: {
    styleFloating () {
      return `margin-top: -${this.margin}px !important;`
    },
    styleCard () {
      return `padding-bottom: ${(parseInt(this.margin) + 16)}px !important;`
    }
  },
  data () {
    return {
      model: {},
    };
  },
};
</script>
